export type FaqItem = {
  question: string
  answer: string
  /** Regroupement affiché sur la page */
  category: 'Candidats' | 'Entreprises' | 'Formation' | 'Financement'
}

/**
 * Questions fréquentes. Ce contenu joue un double rôle :
 * il rassure les visiteurs et il permet d'apparaître sur les
 * recherches Google formulées sous forme de questions.
 */
export const FAQ: FaqItem[] = [
  {
    category: 'Candidats',
    question: "Comment s'inscrire en alternance chez Zillenium Alternance ?",
    answer:
      "Vous déposez votre candidature directement en ligne depuis la page Candidater, ou vous nous appelez au 09 83 49 01 81. Nous vous recontactons pour un entretien de positionnement, puis nous vous accompagnons dans la recherche d'une entreprise d'accueil.",
  },
  {
    category: 'Candidats',
    question: "Faut-il déjà avoir une entreprise pour s'inscrire ?",
    answer:
      "Non. Vous pouvez candidater sans entreprise : notre dispositif CAP 360 vous accompagne avant l'entrée en formation (CV, entretiens, posture professionnelle, mise en relation avec notre réseau). La réglementation permet également de débuter le cycle de formation sous statut de stagiaire de la formation professionnelle pendant trois mois, le temps de signer un contrat d'apprentissage.",
  },
  {
    category: 'Candidats',
    question: 'Quel est l’âge limite pour entrer en apprentissage ?',
    answer:
      "L'apprentissage est ouvert de 16 à 29 ans révolus. Des dérogations existent notamment pour les personnes en situation de handicap, les sportifs de haut niveau et les créateurs ou repreneurs d'entreprise, sans limite d'âge.",
  },
  {
    category: 'Candidats',
    question: 'Quand a lieu la rentrée ?',
    answer:
      'La rentrée en formation a lieu le 25 septembre 2026. Des offres d’alternance sont disponibles dès maintenant, avec un démarrage immédiat possible en entreprise : vous pouvez donc commencer à travailler avant le début des cours. Les places sont limitées, plus vous candidatez tôt, mieux nous vous accompagnons.',
  },
  {
    category: 'Formation',
    question: 'Quelles formations propose Zillenium Alternance ?',
    answer:
      "Nous proposons trois formations en alternance dans le commerce et la relation client : le BTS NDRC (Négociation et Digitalisation de la Relation Client, niveau 5), le Titre Professionnel Conseiller de Vente (niveau 4) et le Titre Professionnel Négociateur Technico-Commercial (niveau 5).",
  },
  {
    category: 'Formation',
    question: 'Où se situe le centre de formation ?',
    answer:
      'Notre CFA est situé au 25 rue Gabriel Cortel, 89300 Joigny, dans l’Yonne (Bourgogne-Franche-Comté). Nous accueillons des apprenants de Joigny, Auxerre, Sens et de l’ensemble du département.',
  },
  {
    category: 'Formation',
    question: 'Quel est le rythme de l’alternance ?',
    answer:
      "Le rythme varie selon la formation : généralement 1 jour en centre de formation et 4 jours en entreprise pour les titres professionnels, et 2 jours en centre pour le BTS NDRC. Le calendrier précis est communiqué avant le début de la formation.",
  },
  {
    category: 'Formation',
    question: 'Zillenium Alternance est-il un organisme certifié ?',
    answer:
      "Oui. Zillenium Alternance est certifié Qualiopi pour les actions de formation et les actions de formation par apprentissage. Nos certificats sont librement téléchargeables depuis la page Documents utiles. Nos formations sont enregistrées au Répertoire National des Certifications Professionnelles (RNCP).",
  },
  {
    category: 'Financement',
    question: 'Combien coûte la formation pour l’apprenti ?',
    answer:
      "Rien. Aucun frais pédagogique, d'inscription ou administratif ne peut être facturé à l'apprenti dans le cadre d'un contrat d'apprentissage. Le coût de la formation est pris en charge par l'opérateur de compétences (OPCO) de l'entreprise.",
  },
  {
    category: 'Financement',
    question: 'Quel salaire perçoit un apprenti ?',
    answer:
      "La rémunération est fixée en pourcentage du SMIC et dépend de l'âge de l'apprenti et de l'année d'exécution du contrat. Une grille détaillée est disponible sur notre page Entreprises.",
  },
  {
    category: 'Entreprises',
    question: 'Quelles aides pour une entreprise qui recrute un alternant ?',
    answer:
      "Pour les entreprises de moins de 250 salariés, l'aide est de 5 000 € par an pour un apprenti préparant un diplôme de niveau 4 et de 4 500 € par an pour un niveau 5. Elle peut atteindre 6 000 € pour l'embauche d'un apprenti en situation de handicap. Appelez-nous pour un calcul précis selon votre situation.",
  },
  {
    category: 'Entreprises',
    question: 'Comment recruter un alternant avec Zillenium Alternance ?',
    answer:
      "Vous nous transmettez votre besoin via la page Entreprises ou par téléphone. Nous sourçons et présélectionnons les candidats, nous vous présentons les profils adaptés, puis nous vous accompagnons dans les démarches administratives (contrat, dépôt OPCO) et le suivi de l'alternant.",
  },
  {
    category: 'Entreprises',
    question: 'Le CFA accompagne-t-il les démarches administratives ?',
    answer:
      "Oui. Vous pouvez nous mandater à titre gratuit pour déposer le contrat d'apprentissage et la convention de formation auprès de votre OPCO. Nous restons également votre interlocuteur pendant toute la durée du contrat.",
  },
]
